import axios from 'axios'
import { API_CONFIG } from '@/config/api.config'

/**
 * Cliente axios para endpoints PÚBLICOS, usados por visitante sem conta.
 *
 * Deliberadamente SEM os interceptors de `services/api.ts`:
 *  - não injeta o Bearer do localStorage (um token velho mandaria header
 *    inútil numa rota que não autentica);
 *  - não tenta refresh nem faz `window.location.href = '/auth'` em 401,
 *    que expulsaria da landing quem só queria falar com o comercial.
 *
 * Rejeita com `AxiosError` cru — `getErrorMessage` de `@/utils/error` já
 * trata essa forma no branch `instanceof AxiosError`.
 */
export const publicApi = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: API_CONFIG.headers,
})
